import { useState, useEffect} from "react";
import { jsx } from "react/jsx-runtime";
import SlideShow from "./SlideShow";
import { BrowserRouter as Router,Route,Routes } from "react-router-dom";

function Home() {
  const [fadeIn, setFadeIn] = useState({
    profile: false,
    intro: false,
    slideshow: false,
    links: false
  });

  useEffect(() => {
    // プロフィール画像がフェードイン
    const profileTimer = setTimeout(() => {
      setFadeIn(prev => ({ ...prev, profile: true }));
    }, 100);

    // 本文がフェードイン
    const introTimer = setTimeout(() => {
      setFadeIn(prev => ({ ...prev, intro: true }));
    }, 600);

    // スライドショーがフェードイン
    const slideshowTimer = setTimeout(() => {
      setFadeIn(prev => ({ ...prev, slideshow: true }));
    }, 1100);

    // リンクがフェードイン
    const linksTimer = setTimeout(() => {
      setFadeIn(prev => ({ ...prev, links: true }));
    }, 1600);

    return () => {
      clearTimeout(profileTimer);
      clearTimeout(introTimer);
      clearTimeout(slideshowTimer);
      clearTimeout(linksTimer);
    };
  }, []);

  return (  
    <div style={{ padding: "10px" }}>
      <div className="aboutMe">
        <title>6451P</title>
        <div className={`profile fade-in ${fadeIn.profile ? 'active' : ''}`}>
          <div className={`profile-image ${fadeIn.profile ? 'active' : ''}`}>
            <img src="./bgIcon.jpg" alt="icon" className="bgIcon"></img>
          </div>
          <div className={`introText fade-in ${fadeIn.intro ? 'active' : ''}`}>
            <div className="introName">
              <h2 className="name">bugs_love</h2>
              <h4>Gaku Maeda</h4>
              <p className="introduction">
                <h3>
                  ボカロP/駆け出しエンジニア</h3>
                公営競技に魅せられた男です。<br />
                自身のスキルを使って、公営競技(主にボートレース)の人気を上げようと活動しています。<br />
              </p>
            </div>
          
            <div className="language">
              <h3>使用言語・ツール</h3>
              <div className="language-grid">
                <div className="language-category">
                  <h4>言語</h4>
                  <p>Java, C#, U#, JavaScript, C</p>
                </div>
                <div className="language-category">
                  <h4>ツール</h4>
                  <p>Unity, React, Spring, Studio One</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`slide-show-wrapper fade-in ${fadeIn.slideshow ? 'active' : ''}`}>
        <SlideShow/>
      </div>
        
     
      <div className={`Links fade-in ${fadeIn.links ? 'active' : ''}`}>
        <div className="Icons">
          <div className="siteIcon">
            <a href="https://github.com/bugs-love">
            <img src="./github-site.png" className="gitLogo"></img>
            </a>
          </div>
          <div className="siteIcon">
            <a href="https://x.com/ijou_busoku">
            <img src="./x-site.png" className="XLogo"></img>
            </a>
          </div>
        </div>
      </div>


    </div>
  );
}
export default Home;